import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const FRAGMENTS = {
  ITEM: '[data-myfragment="Leaderboard.item"]',
};

class Leaderboard extends WebComponent {
  constructor(props) {
    super(props);

    this.handleLoadAction = this.handleLoadAction.bind(this);
  }

  didMount() {
    window.addEventListener('load', this.handleLoadAction);
  }

  willUnmount() {
    window.removeEventListener('load', this.handleLoadAction);
  }

  handleLoadAction() {
    const event = new Event('onLoadBanner');
    const el = [...this.element.querySelectorAll(FRAGMENTS.ITEM)][this.getRandomNumber()];
    el.classList.add('active');
    el.dispatchEvent(event);
  }

  getRandomNumber() {
    const { maxItems } = this.props;
    return Math.floor(Math.random() * maxItems);
  }
}

export default Leaderboard;



// WEBPACK FOOTER //
// ./fe/web-eshop/src/js/components/Leaderboard.js